import { z } from 'zod';

export const InitializeEmailAuthenticationFlowBodySchema = z.object({
  email: z.string().email(),
});

export type InitializeEmailAuthenticationFlowBody = z.infer<
  typeof InitializeEmailAuthenticationFlowBodySchema
>;

export const InitializeEmailAuthenticationFlowResponseSchema = z.object({
  message: z.string(),
});

export type InitializeEmailAuthenticationFlowResponse = z.infer<
  typeof InitializeEmailAuthenticationFlowResponseSchema
>;

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string(),
});

export const LoginResponseSchema = z.object({
  token: z.string(),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const VerifyEmailAuthenticationFlowBodySchema = z.object({
  token: z.string(),
});

export type VerifyEmailAuthenticationFlowBody = z.infer<
  typeof VerifyEmailAuthenticationFlowBodySchema
>;

export const VerifyEmailAuthenticationFlowResponseSchema = z.object({
  token: z.string(),
});

export type VerifyEmailAuthenticationFlowResponse = z.infer<
  typeof VerifyEmailAuthenticationFlowResponseSchema
>;

export const RegisterRequestSchema = z.object({
  email: z.string().email(),
  password: z.string(),
  fullName: z.string(),
  nickname: z.string().nullable(),
  token: z.string(),
});

export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;

export const WhoamiResponseSchema = z.object({
  userId: z.string(),
});

export type WhoamiResponse = z.infer<typeof WhoamiResponseSchema>;
